import { notification } from 'antd';
import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import { ApiContext } from 'utils/networking/Api.context';

export default function usePoliceReportAlloggiatiConfigHook() {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    alloggiatiUser: null,
    alloggiatiPass: null,
    wskey: null,
    suscription: null,
    sendSuscriptionRequestEnabled: true,
  });

  useEffect(() => {
    actions.loadPoliceReportConfig();
  }, [appState.selectedHotel]);

  const actions = {
    loadPoliceReportConfig: () => {
      updateState({ isLoading: true });
      API.getPoliceConfig({ hotelId: getSelectedHotel()?.key })
        .then(res => {
          updateState({
            isLoading: false,
            alloggiatiUser: res?.credentials?.user,
            alloggiatiPass: res?.credentials?.password,
            wskey: res?.credentials?.wskey,
            suscription: res?.suscription === 'active',
          });
        })
        .catch(err => {
          console.warn(err);
          updateState({ isLoading: false });
        });
    },

    // TODO do this after we have credentails for the platform
    // onCheckITAConnection: () => {
    //   updateState({ isLoading: true });
    //   API.policeReportCheckITAConnection({
    //     hotelId: getSelectedHotel()?.key,
    //     itaCredentials: {
    //       username: state.itaUser,
    //       password: state.itaPass,
    //       wskey: state.wskey,
    //     },
    //   })
    //     .then(result => {
    //       updateState({ isLoading: false });

    //       if (result.success) {
    //         notification.success({
    //           message: translate('policeReport.checkITAConnectionSuccess'),
    //         });
    //       } else {
    //         notification.error({
    //           message: translate('policeReport.checkITAConnectionError'),
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       console.warn(err);
    //       updateState({ isLoading: false });
    //       notification.error({
    //         message: translate('policeReport.checkITAConnectionError'),
    //       });
    //     });
    // },

    onSaveAlloggiatiConfig: () => {
      updateState({ isLoading: true });

      API.updatePoliceAlloggiati({
        hotelId: getSelectedHotel()?.key,
        body: {
          user: state.alloggiatiUser,
          password: state.alloggiatiPass,
          wskey: state.wskey,
        },
      })
        .then(_ => {
          updateState({ isLoading: false });
          // API.policeReportCheckITAConnection({
          //   hotelId: getSelectedHotel()?.key,
          //   itaCredentials: {
          //     platform: 'ITA',
          //     username: state.itaUser,
          //     password: state.itaPass,
          //     wskey: state.wskey,
          //   },
          // })
          //   .then(result => {
          //     updateState({ isLoading: false });

          //     if (result.success) {
          //       notification.success({
          //         message: translate('policeReport.checkITAConnectionSuccess'),
          //       });
          //     } else {
          //       notification.error({
          //         message: translate('policeReport.checkITAConnectionError'),
          //       });
          //     }
          //   })
          //   .catch(err => {
          //     console.warn(err);
          //     updateState({ isLoading: false });
          //     notification.error({
          //       message: translate('policeReport.checkITAConnectionError'),
          //     });
          //   });
        })
        .catch(err => {
          //ERROR saving credentials
          console.warn(err);
          updateState({ isLoading: false });
          notification.error({
            message: translate('policeReport.alloggiatiError'),
          });
        });
    },
    isAdmin: () => {
      return appState?.superUser ? true : false;
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
